import { Injectable } from '@angular/core';
import localForage from 'localforage';

@Injectable()
export class StorageService {

    constructor() {
        this.storage = localForage;
    }

    storage: any;
    /**
     * 新标签页打开时判断session值，不存在则设置localstorage,
     * localStorage的值发生变化时监听 ’storage‘事件
     *
     */
    init() {
        if (!sessionStorage.length) {
            // 这个调用能触发目标事件，从而达到共享数据的目的
            localStorage.setItem('getSessionStorage', Date());
        }

        // 该事件是核心
        window.addEventListener('storage', function (event) {
            // console.log(event);
            if (event.key === 'getSessionStorage') {
                // 已存在的标签页会收到这个事件
                localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
                localStorage.removeItem('sessionStorage');

            } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
                // 新开启的标签页会收到这个事件
                const data = JSON.parse(event.newValue);
                // console.log(data);
                for (const key in data) {
                    if (true) {
                        sessionStorage.setItem(key, data[key]);
                    }
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/services/storage.service.ts